import { useContext, useEffect, useState } from 'react';
import { useAddAccountTreatment } from '../../../../sdk/ams/account/UseAddAccountTreatment';
import { useRefreshAccountId } from '../../../../sdk/ams';
import { AccountContext } from '../../AccountContext';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import { FormContainer, Select, SelectOption } from '@app/shared';
import DatePicker from 'react-datepicker';
import { CSSProperties } from 'styled-components';
import './AddTreatment.css';
import { useFormatAndSendTreatmentRequest } from '../hooks/useAddTreatment';
import { useAccountAvailableTreatmentIndicators } from '../../../../sdk/ams/account/UseAccountAvailableTreatmentIndicators';
import { expiryPeriodOptions } from '../../constants/expiry-period-options';

export default function AddTreatment() {
  return (
    <div className="ui segment">
      <div className="ui header">Add Treatment To Account</div>
      <div className="content">
        <div className="ui form">
          <AccountTreatmentForm />
        </div>
      </div>
    </div>
  );
}

function AccountTreatmentForm() {
  const flexRowSpaceBetween: CSSProperties = { display: 'flex', flexDirection: 'row', justifyContent: 'space-between' };
  const [minExpiryDate, setMinExpiryDate] = useState<Date | undefined>(new Date());
  const formContext = useForm<{
    treatmentId: string;
    effectiveDate?: string;
    expiryDate?: string;
    numberOfBillingPeriods?: number | string;
  }>();

  const { accountId, billingDate } = useContext(AccountContext);

  const { data: treatmentIndicators } = useAccountAvailableTreatmentIndicators(accountId);

  const [selectData, setSelectData] = useState<SelectOption[]>([]);



  useEffect(() => {
    const mappedData = treatmentIndicators?.map((indicator) => {
      return {
        label: indicator.name,
        value: indicator.id,
        tooltip: "Will also add flag: " + indicator.accountFlag
      };
    });
    if (treatmentIndicators) {
      setSelectData(mappedData);
    }
  }, [treatmentIndicators]);
  const { mutateAsync: addAccountTreatment, isPending } = useAddAccountTreatment();
  const refreshAccount = useRefreshAccountId(accountId);

  const onAddTreatment = useFormatAndSendTreatmentRequest(accountId, addAccountTreatment, refreshAccount);

  return (
    <FormProvider {...formContext}>
      <FormContainer
        isSubmitting={isPending}
        onSubmit={onAddTreatment}>
        <Select
          options={{ required: 'Treatment is required' }}
          name="treatmentId"
          selectOptions={selectData}
          label="Treatment"
          defaultValue={''}
        />
        <Controller
          name="effectiveDate"
          control={formContext.control}
          render={({ field }) => (
            <div className="sixteen wide column" style={flexRowSpaceBetween}>
              <label className="ui label extra large datepicker-label">Effective date</label>
              <DatePicker
                name="effectiveDate"
                selected={field.value}
                onChange={(date) => {
                  setMinExpiryDate(date);
                  field.onChange(date);
                }}
                dateFormat="dd/MM/yyyy"
                minDate={billingDate}
                placeholderText="Effective date"
                isClearable
              />
            </div>
          )}
        />

        <Controller
          name="expiryDate"
          control={formContext.control}
          render={({ field }) => (
            <div className="sixteen wide column" style={flexRowSpaceBetween}>
              <label className="ui label extra large datepicker-label">Expiry date</label>
              <DatePicker
                name="expiryDate"
                selected={field.value}
                onChange={(date) => {
                  if (date) {
                    formContext.setValue('numberOfBillingPeriods', null);
                  }

                  field.onChange(date);
                }}
                dateFormat="dd/MM/yyyy"
                placeholderText="Expiry date"
                minDate={minExpiryDate}
                isClearable
              />
            </div>
          )}
        />
        <Select
          name="numberOfBillingPeriods"
          onChange={(ev) => {
            if (ev.target.value.length > 0) {
              formContext.setValue('expiryDate', null);
            }
          }}
          selectOptions={expiryPeriodOptions}
          label="Expiry Period"
        />
      </FormContainer>
    </FormProvider>
  );
}
